import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CoreMenuService } from 'src/@core/components/core-menu/core-menu.service';
import { CoreConfigService } from 'src/@core/services/config.service';
import { CoreConfig } from 'src/@core/types';
import { DataService } from 'src/app/helpers/data.service';
import {
  iModuleChild,
  iModulesList,
} from 'src/app/helpers/Interfaces/modules-list';
import { ModulesList } from 'src/app/helpers/modules-list';

@Component({
  selector: 'app-nine-icons',
  templateUrl: './nine-icons.component.html',
  styleUrls: ['./nine-icons.component.scss'],
})
export class NineIconsComponent implements OnInit, OnDestroy {
  @Input() dropdown: any;
  @Input() i: any;
  private _unsubscribeAll = new Subject();
  config!: CoreConfig;
  sections: iModulesList[] = [];

  get isStartup(): boolean {
    return (
      this._dataServ.empTypeValue === 's' ||
      !!this._dataServ.employeeValue?.isStartup
    );
  }

  constructor(
    private _dataServ: DataService,
    private _coreConfigService: CoreConfigService,
    private _coreMenuService: CoreMenuService
  ) {}

  updateSections(): void {
    this.sections = this.isStartup
      ? ModulesList.filter((s) => s.section === 'iNest')
      : ModulesList;
  }

  ngOnInit(): void {
    this.updateSections();

    this._dataServ.employee$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        this.updateSections();
      });

    this._dataServ.empType$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        this.updateSections();
      });

    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config: CoreConfig) => {
        this.config = { ...config };
      });
  }
  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
  handleExternalUrl(module: iModuleChild) {
    if (!this._dataServ.checkDomain()) {
      //alert('nine-icons.components.ts')
      this._dataServ.clear(true);
      window.location.reload();
      return;
    }

    if (module.link) {
      window.location.href = module.link;
    }
  }
}
